const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const NICKNAME_RE = /^[가-힣A-Za-z0-9_.-]{2,20}$/;

export function validateEmail(value: string): string | null {
  if (!value) return "이메일을 입력해주세요";
  if (!EMAIL_RE.test(value)) return "올바른 이메일 형식이 아닙니다";
  return null;
}

export function validatePassword(value: string): string | null {
  if (value.length < 6) return "비밀번호는 6자 이상이어야 합니다";
  return null;
}

export function validateNickname(value: string): string | null {
  if (!NICKNAME_RE.test(value)) {
    return "닉네임은 2~20자의 한글/영문/숫자/._- 만 허용됩니다";
  }
  return null;
}

/** Convert full-width characters (common with Korean IMEs) to ASCII and strip whitespace. */
export function normalizeEmail(value: string): string {
  return value
    .replace(/[！-～]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0))
    .replace(/\s+/g, "");
}

export function validateImage(file: File): string | null {
  if (!file.type.startsWith("image/")) return "이미지 파일만 업로드할 수 있습니다";
  if (file.size > 5 * 1024 * 1024) return "이미지는 5MB 이하여야 합니다";
  return null;
}
